// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo___2gpiL","sider":"sider___2h32z","ligth":"ligth___3DQ1a","icon":"icon___3BUp2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ant-design-pro/SiderMenu/index.less
// module id = tYnY
// module chunks = 2